import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import * as actions from '../../actions/index';

function Layout({ showSidebarCollapse, showSidebar, sidebarCollapse, sidebarShow, showModal, activeItem }) {
  const changeSidebarVisibility = () => {
    showSidebarCollapse(!sidebarCollapse);
  };

  const changeMobileSidebarVisibility = () => {
    showSidebar(!sidebarShow);
  };


  const layoutClass = classNames({
    layout: true,
    'layout--collapse': sidebarCollapse
  });

  return (
    <div className={layoutClass}>
      <Navbar
        changeMobileSidebarVisibility={changeMobileSidebarVisibility}
        changeSidebarVisibility={changeSidebarVisibility}
        showModal={showModal}
      />
      <Sidebar
        sidebarShow={sidebarShow}
        sidebarCollapse={sidebarCollapse}
        changeMobileSidebarVisibility={changeMobileSidebarVisibility}
        activeItem={activeItem}
      />
    </div>
  );

}
function mapStateToProps({ sidebar }) {
  const { sidebarShow, sidebarCollapse, activeItem } = sidebar;
  return {
    sidebarShow,
    sidebarCollapse,
    activeItem
  };
}

export default connect(mapStateToProps, actions)(Layout);
